<template>
  <div
    class="animate-pulse bg-gray-100"
    :style="{ height: `${height}px` }"
  />
</template>

<script>
export default {
  name: 'Skeleton',

  props: {
    height: {
      required: true,
      type: Number,
    },
  },
};
</script>
